import { Box, Typography } from "@mui/material"
import { footerConfig, footerOptionsConfig } from "./config/footer.config"
import { useFooter } from "./hooks/useFooter"

export const Footer = () => {
    const { handlePrivacyPolicyClick, handleTermsOfServiceClick, handleContactSupportClick } = useFooter()
    return (
        <Box sx={footerConfig}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", px: 4, py: 2 }}>
                <Box>
                    <Typography>© 2026 Flownect. All rights reserved.</Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", gap: 4 }}>
                    <Typography onClick={handlePrivacyPolicyClick} sx={footerOptionsConfig}>Privacy Policy</Typography>
                    <Typography onClick={handleTermsOfServiceClick} sx={footerOptionsConfig}>Terms of Service</Typography>
                    <Typography onClick={handleContactSupportClick} sx={footerOptionsConfig}>Contact Support</Typography>
                </Box>
            </Box>
        </Box>
    )
}